import { filterRecentItemsByLink, listsActionTypes } from './Constants';

const initialState = {
	loading: true,
	loadingFolders: true,
	loadingLessons: false,
	recentLists: {},
	madeLists: [],
	folders: [],
	lessons: [],
	bannerLoading: false,
	loadingRecentItems: false,
	recentItems: {},
};

export default function listsReducer(state = initialState, { type, payload }) {
	const { recentLists, madeLists, folders, lessons, id, listType, inMenu, data, offset, update } =
		payload || {};

	switch (type) {
		case listsActionTypes.GET_RECENT_LISTS_REQUEST:
		case listsActionTypes.GET_MADE_LISTS_REQUEST:
		case listsActionTypes.CREATE_FOLDER_REQUEST:
		case listsActionTypes.SET_LOADING:
			return {
				...state,
				loading: !update,
			};

		case listsActionTypes.GET_RECENT_ITEMS_REQUEST:
			return {
				...state,
				loadingRecentItems: !offset,
			};

		case listsActionTypes.GET_RECENT_ITEMS_SUCCESS:
			return {
				...state,
				recentItems: data,
				loadingRecentItems: false,
			};

		case listsActionTypes.GET_RECENT_ITEMS_ERROR:
			return {
				...state,
				loadingRecentItems: false,
			};

		case listsActionTypes.GET_RECENT_LESSONS_REQUEST:
			return {
				...state,
				loadingLessons: true,
			};

		case listsActionTypes.RESEND_EMAIL_VERIFICATION_REQUEST:
			return {
				...state,
				bannerLoading: true,
			};

		case listsActionTypes.HIDE_RECENT_ITEM_SUCCESS:
			const lists = { ...state.recentItems };
			return {
				...state,
				recentItems: filterRecentItemsByLink(lists, listType, id),
			};

		case listsActionTypes.GET_RECENT_LISTS_SUCCESS:
			return {
				...state,
				loading: false,
				recentLists,
			};

		case listsActionTypes.GET_MADE_LISTS_SUCCESS:
			return {
				...state,
				loading: false,
				madeLists,
			};

		case listsActionTypes.GET_FOLDERS_REQUEST:
			return {
				...state,
				loadingFolders: true,
				loading: !inMenu,
			};

		case listsActionTypes.GET_FOLDERS_SUCCESS:
			return {
				...state,
				loading: false,
				loadingFolders: false,
				folders,
			};

		case listsActionTypes.GET_FOLDERS_ERROR:
			return {
				...state,
				loading: false,
				loadingFolders: false,
			};

		case listsActionTypes.GET_RECENT_LESSONS_SUCCESS:
			return {
				...state,
				loadingLessons: false,
				lessons,
			};

		case listsActionTypes.RESEND_EMAIL_VERIFICATION_SUCCESS:
		case listsActionTypes.RESEND_EMAIL_VERIFICATION_ERROR:
			return {
				...state,
				bannerLoading: false,
			};

		case listsActionTypes.GET_RECENT_LISTS_ERROR:
		case listsActionTypes.GET_MADE_LISTS_ERROR:
		case listsActionTypes.CREATE_FOLDER_ERROR:
			return {
				...state,
				loading: false,
			};
		case listsActionTypes.GET_RECENT_LESSONS_ERROR:
			return {
				...state,
				loadingLessons: false,
			};

		case listsActionTypes.CLEAN_LISTS_STATE:
			return initialState;

		case listsActionTypes.CLEAN_MADE_LIST_STATE:
			return {
				...state,
				loading: true,
				madeLists: [],
			};

		default:
			return state;
	}
}
